import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Register from "../../components/InvitationOnboarding/Register";
import CurrentPractice from "../../components/InvitationOnboarding/CurrentPractice";
import Education from "../../components/InvitationOnboarding/Education";
import ProfessionalLicense from "../../components/InvitationOnboarding/ProfessionalLicense";
import CompleteProfile from "../../components/InvitationOnboarding/CompleteProfile";
import { useLocation } from "react-router-dom";
import { useTeams } from "../../contexts/Teams";
import { useParams, useSearchParams } from "react-router-dom";
import { Container } from "@mui/material";

const InvitationOnboarding = () => {
  const location = useLocation();
  const inviteUrl = location.pathname + location.search + location.hash;;
  const { organizationData, checkUrl, step, invitationState } = useTeams();
  const { url } = useParams();
  const [searchParams] = useSearchParams();
  const expires = searchParams.get("expires");
  const signature = searchParams.get("signature");
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLicensed, setIsLicensed] = useState(true);

  if (localStorage.getItem('invitationURL') !== inviteUrl) {
    localStorage.setItem('invitationURL', inviteUrl);
  }

  useEffect(() => {
    const validateUrl = async () => {
      try {
        const response = await checkUrl({
          route: "teams.invite",
          expires,
          signature,
          signed_url: url,
        });
        // const isMentalHealthProvider =
        //   response?.data?.data?.params.role === "Mental Health Provider";
        setIsLicensed(response?.data?.data?.params.invite_as_mental_health);
      } catch (error) {
        if (error.message.includes("Link expired")) {
          setIsLinkExpired(true);
        }
      } finally {
        setIsLoading(false);
      }
    };
    validateUrl();
  }, [url]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      localStorage.removeItem("invitationStep");
      localStorage.removeItem("invitationState");
      window.location.reload();
    }, 10 * 60 * 1000);

    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return (
      <Container maxWidth="sm">
        <Paper
          sx={{
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "primary.light",
              pt: 4,
              px: 4,
              pb: 3,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
            }}
          >
            <Skeleton animation="wave" sx={{ minHeight: 30 }} />
            <Skeleton animation="wave" sx={{ minHeight: 30 }} />
            <Skeleton animation="wave" sx={{ minHeight: 30 }} />
            <Skeleton animation="wave" sx={{ minHeight: 30 }} />
          </Box>
        </Paper>
      </Container>
    );
  }

  if (isLinkExpired) {
    return (
      <Container maxWidth="sm">
        <Paper
          sx={{
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "primary.light",
              pt: 4,
              px: 4,
              pb: 3,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
            }}
          >
            <Typography variant="h4" gutterBottom>
              Hello, this link has expired.
            </Typography>
            <Typography>
              To get a new link, please contact your administrator. We look
              forward to seeing you in the community.
            </Typography>
            <Typography mt={2}>
              Thank you
              <br />
              <b>The Trusted Therapist Network Team</b>
            </Typography>
          </Box>
        </Paper>
      </Container>
    );
  }

  return (
    <Box>
      {/* Step 1: Register for all users */}
      {step === 1 && <Register isLicensed={isLicensed} role={organizationData?.params.role}/>}
      
      {/* Steps for licensed users only */}
      {isLicensed ? (
        <>
          {step === 2 && <CurrentPractice role={organizationData?.params.role}/>}
          {step === 3 && <Education role={organizationData?.params.role}/>}
          {step === 4 && <ProfessionalLicense role={organizationData?.params.role}/>}
          {step === 5 && <CompleteProfile isLicensed={isLicensed} role={organizationData?.params.role}/>}
        </>
      ) : (
        // For non-licensed users, only show CompleteProfile as step 2
        step === 2 && <CompleteProfile isLicensed={isLicensed} role={organizationData?.params.role}/>
      )}
    </Box>
  );
};

export default InvitationOnboarding;